import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import { PropTypes, describe } from 'react-desc';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';

var renderPaths = function renderPaths(paths) {
  return paths.map(function (p, i) {
    return /*#__PURE__*/React.createElement("path", {
      key: i,
      d: p
    });
  });
};

function SvgIcon(_ref) {
  var _ref$containerProps = _ref.containerProps,
      containerProps = _ref$containerProps === void 0 ? {} : _ref$containerProps,
      size = _ref.size,
      color = _ref.color,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'span' : _ref$component,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      paths = _ref.paths,
      fill = _ref.fill,
      innerRef = _ref.innerRef,
      rest = _objectWithoutProperties(_ref, ["containerProps", "size", "color", "className", "component", "viewBox", "paths", "fill", "innerRef"]);

  var _convertPropToCssClas = convertPropToCssClassName('icon', className, {
    size: size,
    color: color
  }),
      cssClassName = _convertPropToCssClas.cssClassName;

  return /*#__PURE__*/React.createElement(Component, _extends({
    ref: innerRef,
    className: cssClassName
  }, rest, containerProps), /*#__PURE__*/React.createElement("svg", {
    fill: fill,
    viewBox: viewBox
  }, renderPaths(paths)));
}

var iconProps = {
  containerProps: PropTypes.object.description('set of properties attached to the main container'),
  size: PropTypes.oneOf(['xxs, xs, s, m, l, xl, xxl']).description('size of the icon'),
  color: PropTypes.oneOf([['neutral', '900'], ['neutral', '0'], ['danger', '900'], ['warning', '500'], ['success', '900'], ['brand-primary', '600']]).description('icon color'),
  className: PropTypes.string.description('html class attribute'),
  component: PropTypes.oneOf([PropTypes.string, PropTypes.node]).description('containers element'),
  viewBox: PropTypes.string.description('view box'),
  paths: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).description(''),
  fill: PropTypes.string.description('fill attribute'),
  innerRef: PropTypes.object.description('inner ref')
};
SvgIcon.propTypes = iconProps;
var IconWithSchema = describe(SvgIcon);
IconWithSchema.propTypes = iconProps;

export default SvgIcon;
export { IconWithSchema };
//# sourceMappingURL=SvgIcon.js.map
